import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        planningGroup: '=',
        courseTargets: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Add target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <list-empty ng-if="!vm.PlanningGroupTargetService.availableTargets.length" list="vm.PlanningGroupTargetService.availableTargets" show-add-message="false"></list-empty>
            <div ng-if="vm.PlanningGroupTargetService.availableTargets.length" class="dataTables_wrapper">
                <table class="data01">
                    <thead>
                        <tr role="row">
                            <th class="w1p checkbox sorting_disabled" rowspan="1" colspan="1">
                                <input ng-click="vm.PlanningGroupTargetService.toggleAll()" ng-model="vm.PlanningGroupTargetService.checked" type="checkbox">
                            </th>
                            <th>{{ 'planningGroup.Department' | translate }}</th>
                            <th>{{ 'planningGroup.Role' | translate }}</th>
                            <th>{{ 'planningGroup.Level' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="target in vm.PlanningGroupTargetService.availableTargets">
                            <td class="w1p checkbox">
                                <input
                                     ng-checked="vm.PlanningGroupTargetService.hasTarget(target.id)"
                                     type="checkbox"
                                     ng-click="$event.stopPropagation();vm.PlanningGroupTargetService.toggleTarget(target.id)"
                                >
                            </td>
                            <td>
                                <span ng-if="target.departmentName">{{ target.departmentName }}</span>
                                <span ng-if="!target.departmentName">{{ 'planningGroup.All departments' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.roleName">{{ target.roleName }}</span>
                                <span ng-if="!target.roleName">{{ 'planningGroup.All roles' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.levelName">{{ target.levelName }}</span>
                                <span ng-if="!target.levelName">{{ 'planningGroup.All levels' | translate }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button ng-if="vm.PlanningGroupTargetService.selectedTargetIds.length" class="btn main" type="button" ng-click="vm.save()">
                        {{ 'general.Add' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor (PlanningGroupTargetService) {
        this.PlanningGroupTargetService = PlanningGroupTargetService;
    }

    $onInit () {
        this.PlanningGroupTargetService.setPlanningGroup(this.planningGroup);
        this.PlanningGroupTargetService.setTargets(this.courseTargets);
        this.PlanningGroupTargetService.init();
    }

    save () {
        this.PlanningGroupTargetService.save().then(() => this.uibModalInstance.close());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planningGroup/target/add/index.js